<template>

  <main class="main">

    <the-nav-titles></the-nav-titles>

    <div class="container">

      <h1 class="title title_h1">{{ title }}</h1>

    </div>

    <div
      v-if="!loaded"
      class="loader"
    ></div>

    <div
      v-else
      class="container"
    >

      <div
        v-for="(section, index) in sections"
        :key="index"
        class="layout layout_default-page"
      >

        <div class="layout__item">

          <h2 class="title title_h2">{{ section.title }}</h2>

        </div>

        <div
          v-html="section.text"
          class="layout__item privacy"
        >
        </div>
      </div>

      <div
        class="layout layout_default-page"
      >

        <div class="layout__item">
        </div>

        <div
          class="layout__item"
        >
        <h3 class="privacy__title">Cookie tecnici</h3>
        <div class="privacy__container">
          <p class="privacy__text">Questi cookie non possono essere disattivati perché necessari al buon funzionamento dei nostri servizi. Garantiscono la normale navigazione e fruizione del sito web.</p>
          <img class="privacy__icon" src="/static/info.svg" alt="info"/>
        </div>

        <div class="privacy__container--with-switch">
          <h3 class="privacy__title">Cookie analitici</h3>
          <div class="privacy__line"></div>
          <label class="switch">
            <input class="switch__input" type="checkbox" @click="toggleGta" v-model="gtaEnabled">
            <div class="slider round"></div>
          </label>
        </div>
        <div class="privacy__container">
           <p class="privacy__text">Utilizziamo questi cookie per questi cookie per raccogliere informazioni, in forma aggregata, sul numero degli utenti e su come questi visitano il sito stesso tramite Google Analitics, al fine di migliorare le performance del sito.</p>
           <img class="privacy__icon" src="/static/info.svg" alt="info"/>
        </div>
       </div>
      </div>

    </div>

  </main>

</template>

<script>
  import TheNavTitles from '@/components/TheNavTitles';
  import Cookie from '@/js/Cookie';

  let gtaEnabled = Cookie.get('gta_disabled') === '0' ? true : false;

  export default {
    name: 'PrivacyPolicyPage',

    components: {
      TheNavTitles,
    },

    data() {
      return {
        loaded: false,
        sections: [],
        title: 'Privacy policy',
        gtaEnabled: Cookie.get('gta_disabled') === '0' ? true : false,
      };
    },

    created() {
      this.fetchData();
      gtaEnabled = Cookie.get('gta_disabled') === '0' ? true : false;
    },

    methods: {
      fetchData() {
        this.$http.get('/static/api/privacyPolicy.json')

        .then(this.onFulfilled);
      },

      onFulfilled(res) {
        const data = res.data;

        this.sections = data.content.sections;

        this.loaded = true;
      },

      toggleGta() {
        console.log('1', gtaEnabled);
        gtaEnabled = !gtaEnabled;
        Cookie.set('gta_disabled', gtaEnabled ? '0' : '1', {
          expires: 31536000,
        });
        window['ga-disable-UA-91170168-12'] = !gtaEnabled;
        console.log('2', gtaEnabled);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/privacy-policy/Index.vue